import paper from 'paper';

import { Line2D, Point2D } from '@paragon/geometry-library';

function toPoint2D(point: paper.Point): Point2D {
  return new Point2D(point.x, point.y);
}

function toLine2D(pointA: paper.Point, pointB: paper.Point): Line2D {
  return Line2D.fromPoints(toPoint2D(pointA), toPoint2D(pointB));
}

export function toPaperPoint(point: Point2D): paper.Point {
  return new paper.Point(point.x, point.y);
}

export function projectOntoLine(pointA: paper.Point, pointB: paper.Point, dragPoint: paper.Point): paper.Point {
  return toPaperPoint(toPoint2D(dragPoint).projectOntoLine(toLine2D(pointA, pointB)));
}
